// API地址配置工具

// 调试: 查看环境变量是否正确加载
console.log('API环境变量: https://bobby88888.com');

/**
 * 处理URL，将相对路径转换为完整路径
 * 使用固定的 http://bobby88888.com 作为API前缀
 * @param {string} url - 相对路径URL
 * @returns {string} - 完整的API URL
 */
export const getApiUrl = (url) => {
  // 如果是完整URL，直接返回
  if (url.startsWith('http')) {
    return url;
  }

  // 确保url以/开头
  const path = url.startsWith('/') ? url : `/${url}`;
  
  // 使用固定的API基础URL
  const apiBaseUrl = 'https://bobby88888.com';
  
  return `${apiBaseUrl}${path}`;
};

/**
 * 获取资源的完整URL
 * 主要用于图片等资源的URL转换
 * @param {string} url - 资源URL或路径
 * @returns {string} - 完整的资源URL
 */
export const getResourceUrl = (url) => {
  // 如果已经是完整URL，直接返回
  if (url.startsWith('http')) {
    return url;
  }

  // 确保url以/开头
  const path = url.startsWith('/') ? url : `/${url}`;
  
  // 使用固定的API基础URL
  const apiBaseUrl = 'https://bobby88888.com';
  
  return `${apiBaseUrl}${path}`;
}; 